import { useGetExtraAddOnsForListingAndPricingPackageQuery } from "~graphql/generated/graphql"

export default function useExtraAddOnsForListingAndPricingPackage({
    listingId,
    pricingPackageId,
}: {
    listingId: string
    pricingPackageId: string
}) {
    const {
        data,
        loading: isLoading,
        error,
    } = useGetExtraAddOnsForListingAndPricingPackageQuery({
        variables: { listingId, pricingPackageId },
    })
    const addOns = data?.getExtraAddOnsForListingAndPricingPackage || []

    return { addOns, isLoading, error }
}
